import { DATA_STATE_VALID, DATA_STATE_INVALID, VARIANT_SMALL, VARIANT_LARGE, ELEMENT_LABEL, ELEMENT_UPLOAD_BUTTON, ELEMENT_CANCEL_BUTTON, ELEMENT_DELETE_BUTTON, ELEMENT_INLINE_MESSAGE, ELEMENT_DROP_ZONE_MESSAGE, ELEMENT_BOX, } from '../../constants';
import { getBorderStyle, getBorderWidth, getBorderRadius, } from '../../borders/borders.alias';
import { getBorderColor } from '../../colors/colors.alias';
import getIcons from '../../icons/icons.alias';
import { constants as Button } from '../Button';
import { constants as Label } from '../Label';
import { constants as Subtext } from '../Subtext';
import { constants as IconButton } from '../IconButton';
import { constants as InlineMessage } from '../InlineMessage';
export const constants = Object.freeze({
    NAME: 'FileUpload',
    variants: {
        VARIANT_LARGE,
        VARIANT_SMALL,
    },
    dataStates: {
        DATA_STATE_VALID,
        DATA_STATE_INVALID,
    },
    elements: {
        ELEMENT_LABEL,
        ELEMENT_DROP_ZONE_MESSAGE,
        ELEMENT_BOX,
        ELEMENT_CANCEL_BUTTON,
        ELEMENT_UPLOAD_BUTTON,
        ELEMENT_DELETE_BUTTON,
        ELEMENT_INLINE_MESSAGE,
    },
});
export default function getFileUpload(transformer, config) {
    const borderStyle = getBorderStyle(transformer, config);
    const borderColor = getBorderColor(transformer, config);
    const borderWidth = getBorderWidth(transformer, config);
    const borderRadius = getBorderRadius(transformer, config);
    const icons = getIcons();
    return Object.freeze({
        constants,
        elements: {
            [ELEMENT_LABEL]: {
                components: {
                    [Label.NAME]: {
                        variant: Label.variants.VARIANT_FORM,
                    },
                },
            },
            [ELEMENT_DROP_ZONE_MESSAGE]: {
                component: {
                    [Subtext.NAME]: {
                        variant: Subtext.variants.VARIANT_MEDIUM,
                    },
                },
            },
            [ELEMENT_UPLOAD_BUTTON]: {
                components: {
                    [Button.NAME]: {
                        variant: Button.variants.VARIANT_SECONDARY,
                        iconName: icons.action.add.value,
                    },
                },
            },
            [ELEMENT_CANCEL_BUTTON]: {
                components: {
                    [IconButton.NAME]: {
                        variant: IconButton.variants.VARIANT_PLAIN_MEDIUM,
                        iconName: icons.action.close.value,
                    },
                },
            },
            [ELEMENT_DELETE_BUTTON]: {
                components: {
                    [IconButton.NAME]: {
                        variant: IconButton.variants.VARIANT_PLAIN_MEDIUM,
                        iconName: icons.action.delete.value,
                    },
                },
            },
            [ELEMENT_BOX]: {
                styles: {
                    borderStyle: borderStyle.containerDragAndDrop.value,
                    borderColor: borderColor.containerDragAndDrop.value,
                    borderWidth: borderWidth.containerDragAndDrop.value,
                    borderRadius: borderRadius.containerDragAndDrop.value,
                },
            },
            [ELEMENT_INLINE_MESSAGE]: {
                components: {
                    [InlineMessage.NAME]: {
                        variant: InlineMessage.variants.VARIANT_DEFAULT,
                    },
                },
            },
        },
    });
}
